import { RosterType, StaffType } from 'models/kitchen-roster.model';
import { createContext, useContext } from 'react';

export type WeeklyRosterContextType = {
  addRosterFormData: RosterType[];
  setAddRosterFormData: (data: RosterType[]) => void;
  staff: StaffType[];
  year: number;
  setYear: (year: number) => void;
  department: { name: string; value: string };
  setDepartment: (date: { name: string; value: string }) => void;
};

export const WeeklyRosterContext = createContext({} as WeeklyRosterContextType);

const useWeeklyRosterContext = () => {
  const context = useContext(WeeklyRosterContext);
  return context;
};

export default useWeeklyRosterContext;
